import axios from 'axios';

const parseData = (responseData) => {
    let data = responseData;

    if (typeof data !== 'object') {
        data = [];
    }

    return data;
};

export const getContactFields = async () => {
    const { data } = await axios.get('/app/fieldValueFunnel/contactFields');
    const parsedData = parseData(data);

    return Object.entries(parsedData).map(([key, value]) => {
        return {
            label: value[0],
            value: key,
            isNumeric: value[1],
        };
    });
};

export const getFieldValueConfig = async (fileBoxId) => {
    const { data } = await axios.get(`/app/fieldValueFunnel/${fileBoxId}`);
    const parsedData = parseData(data);

    if (!Array.isArray(parsedData) || !parsedData.length) {
        return [];
    }

    return parsedData[0];
};

export const save = async (cellValueFileBoxId, payload) => {
    const { data } = await axios.put(`/app/fieldValueFunnel/${cellValueFileBoxId}`, payload);

    return data;
};

export const loadFieldValueCode = async (payload) => {
    const response = await axios.post(
        '/app/fieldValueFunnel/renderVueFieldValueConfig',
        payload,
        {
            headers: {
                /* needed so the ContentNegotiatingViewResolver treats the jsp call that happens in
                 * the backend as a jstl request instead of a json one. Otherwise, we'll get a
                 * serialization exception and a broken response. */
                Accept: 'text/html; charset=utf-8',
            },
        },
    );

    return response.data;
};
